import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5","key":"svg-0"}],["path",{"d":"M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-1"}]]

const IconRotateDot = createReactComponent('outline', 'rotate-dot', 'RotateDot', __iconNode);

export default IconRotateDot;